function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React from 'react';
import { Path } from "react-native-svg-web";

import StyledSVG from "./styled";








export const SonntagIcon = ({
  iconPath = '',
  color = '',
  hover = '',
  size = 24,
  ...rest }) => /*#__PURE__*/

React.createElement(StyledSVG, _extends({},
rest, {
  color: color,
  hover: hover,
  width: `${size}px`,
  height: `${size}px`,
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg" }), /*#__PURE__*/

React.createElement(Path, { d: iconPath }));